module.exports = __webpack_public_path__ + "img/opinionlab-2018-report.3ee826d7.jpg";